import React from 'react';
import { motion } from 'framer-motion';

const PriceDisplay = ({ cryptoType, amount, rate, estimatedPrice, commission, total }) => {
  const containerVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="bg-white/10 border border-white/30 rounded-lg p-6 space-y-4"
    >
      <div className="grid grid-cols-2 gap-4">
        <motion.div
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1 }}
          className="text-center"
        >
          <p className="text-gray-400 text-sm mb-1">Amount</p>
          <p className="text-white text-2xl font-bold">{amount} {cryptoType}</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1 }}
          className="text-center"
        >
          <p className="text-gray-400 text-sm mb-1">Current Rate</p>
          <p className="text-white text-2xl font-bold">${rate.toLocaleString()}</p>
        </motion.div>
      </div>

      <div className="border-t border-white/20 pt-4 space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-gray-300">Currency Value:</span>
          <span className="text-white font-semibold">${parseFloat(estimatedPrice).toLocaleString()}</span>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="bg-amber-500/20 border border-amber-500/50 rounded p-3 flex justify-between items-center"
        >
          <span className="text-amber-300 font-semibold">10% Commission:</span>
          <span className="text-amber-200 font-bold">${parseFloat(commission).toLocaleString()}</span>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.3 }}
        className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg p-4 flex justify-between items-center"
      >
        <span className="text-white font-bold text-lg">Total Amount:</span>
        <span className="text-white font-bold text-2xl">${parseFloat(total).toLocaleString()}</span>
      </motion.div>
    </motion.div>
  );
};

export default PriceDisplay;
